import { WorkDay } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const WORK_DAY_FIND = createAction('[Work Day] Find');
export const WORK_DAY_FIND_SUCCESS = createAction('[Work Day] Find Success', props<{ workDay: WorkDay | null }>());
export const WORK_DAY_FAILED = createAction('[Work Day] Failed', props<{ error: string }>());
export const WORK_DAY_UPDATE_LOADING = createAction('[Work Day] Update Loading', props<{ loading: boolean }>());
